import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ProductPage } from './components/ProductPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { CartProvider } from './context/CartContext';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <CartProvider data-id="element-1">
        <BrowserRouter data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<ProductPage data-id="element-5" />} data-id="element-4" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-7" />} data-id="element-6" />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </div>;
}